/**
 * Official Gati Sutra branding assets (served from /public/branding).
 */
export const BRAND_NAME = 'Gati Sutra';
export const BRAND_TAGLINE = 'Integrated Transport Management System';

/** Small square mark — favicon, compact headers, email icon. */
export const BRAND_MARK_SRC = '/branding/logo.png';

/** Full horizontal wordmark + icon. */
export const BRAND_FULL_SRC = '/branding/gati-sutra-logo.png';

export const BRAND_FAVICON_SRC = '/branding/favicon-32.png';
export const BRAND_APPLE_TOUCH_SRC = '/branding/apple-touch-icon.png';
